import { isBRServer } from '@/utils/Validators/validation';

export const GATOR_PROTECT_ID = {
  PRO: isBRServer ? 566 : 341,
  TRIAL: isBRServer ? 563 : 338,
  FREE: isBRServer ? 560 : 335,
};
